module.exports = __webpack_public_path__ + "img/Weapon_79.dffd6e4d.png";